module.exports = __webpack_public_path__ + "img/vertical_7_7_0.c51bcdbf.png";